/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DistributionBoardSnapshot
 */
export interface DistributionBoardSnapshot {
    /**
     *
     * @type {string}
     * @memberof DistributionBoardSnapshot
     */
    uniqueId?: string;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    externalLoadL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    externalLoadL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    externalLoadL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    connectorsAssignedL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    connectorsAssignedL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    connectorsAssignedL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    feedbackExternalLoadL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    feedbackExternalLoadL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    feedbackExternalLoadL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    feedbackConnectorsLoadL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    feedbackConnectorsLoadL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    feedbackConnectorsLoadL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    operatingCapacityL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    operatingCapacityL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof DistributionBoardSnapshot
     */
    operatingCapacityL3Amps?: number;
}

/**
 * Check if a given object implements the DistributionBoardSnapshot interface.
 */
export function instanceOfDistributionBoardSnapshot(
    value: object,
): value is DistributionBoardSnapshot {
    return true;
}

export function DistributionBoardSnapshotFromJSON(
    json: any,
): DistributionBoardSnapshot {
    return DistributionBoardSnapshotFromJSONTyped(json, false);
}

export function DistributionBoardSnapshotFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DistributionBoardSnapshot {
    if (json == null) {
        return json;
    }
    return {
        uniqueId: json["uniqueId"] == null ? undefined : json["uniqueId"],
        externalLoadL1Amps:
            json["externalLoadL1Amps"] == null
                ? undefined
                : json["externalLoadL1Amps"],
        externalLoadL2Amps:
            json["externalLoadL2Amps"] == null
                ? undefined
                : json["externalLoadL2Amps"],
        externalLoadL3Amps:
            json["externalLoadL3Amps"] == null
                ? undefined
                : json["externalLoadL3Amps"],
        connectorsAssignedL1Amps:
            json["connectorsAssignedL1Amps"] == null
                ? undefined
                : json["connectorsAssignedL1Amps"],
        connectorsAssignedL2Amps:
            json["connectorsAssignedL2Amps"] == null
                ? undefined
                : json["connectorsAssignedL2Amps"],
        connectorsAssignedL3Amps:
            json["connectorsAssignedL3Amps"] == null
                ? undefined
                : json["connectorsAssignedL3Amps"],
        feedbackExternalLoadL1Amps:
            json["feedbackExternalLoadL1Amps"] == null
                ? undefined
                : json["feedbackExternalLoadL1Amps"],
        feedbackExternalLoadL2Amps:
            json["feedbackExternalLoadL2Amps"] == null
                ? undefined
                : json["feedbackExternalLoadL2Amps"],
        feedbackExternalLoadL3Amps:
            json["feedbackExternalLoadL3Amps"] == null
                ? undefined
                : json["feedbackExternalLoadL3Amps"],
        feedbackConnectorsLoadL1Amps:
            json["feedbackConnectorsLoadL1Amps"] == null
                ? undefined
                : json["feedbackConnectorsLoadL1Amps"],
        feedbackConnectorsLoadL2Amps:
            json["feedbackConnectorsLoadL2Amps"] == null
                ? undefined
                : json["feedbackConnectorsLoadL2Amps"],
        feedbackConnectorsLoadL3Amps:
            json["feedbackConnectorsLoadL3Amps"] == null
                ? undefined
                : json["feedbackConnectorsLoadL3Amps"],
        operatingCapacityL1Amps:
            json["operatingCapacityL1Amps"] == null
                ? undefined
                : json["operatingCapacityL1Amps"],
        operatingCapacityL2Amps:
            json["operatingCapacityL2Amps"] == null
                ? undefined
                : json["operatingCapacityL2Amps"],
        operatingCapacityL3Amps:
            json["operatingCapacityL3Amps"] == null
                ? undefined
                : json["operatingCapacityL3Amps"],
    };
}

export function DistributionBoardSnapshotToJSON(
    value?: DistributionBoardSnapshot | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        uniqueId: value["uniqueId"],
        externalLoadL1Amps: value["externalLoadL1Amps"],
        externalLoadL2Amps: value["externalLoadL2Amps"],
        externalLoadL3Amps: value["externalLoadL3Amps"],
        connectorsAssignedL1Amps: value["connectorsAssignedL1Amps"],
        connectorsAssignedL2Amps: value["connectorsAssignedL2Amps"],
        connectorsAssignedL3Amps: value["connectorsAssignedL3Amps"],
        feedbackExternalLoadL1Amps: value["feedbackExternalLoadL1Amps"],
        feedbackExternalLoadL2Amps: value["feedbackExternalLoadL2Amps"],
        feedbackExternalLoadL3Amps: value["feedbackExternalLoadL3Amps"],
        feedbackConnectorsLoadL1Amps: value["feedbackConnectorsLoadL1Amps"],
        feedbackConnectorsLoadL2Amps: value["feedbackConnectorsLoadL2Amps"],
        feedbackConnectorsLoadL3Amps: value["feedbackConnectorsLoadL3Amps"],
        operatingCapacityL1Amps: value["operatingCapacityL1Amps"],
        operatingCapacityL2Amps: value["operatingCapacityL2Amps"],
        operatingCapacityL3Amps: value["operatingCapacityL3Amps"],
    };
}
